import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * Allergies forms
   */
  {
    // 1
    field: 'allergiesSymptoms',
    label:
      'On a typical day, what kind of symptoms are you generally experiencing? What is the severity of your symptoms?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'itchyWatery',
          value: 'Itchy/watery eyes',
          answer: {
            type: 'radio',
            name: 'itchyWateryOption',
            options: [
              { key: 'Mild', value: 'Mild' },
              { key: 'Moderate', value: 'Moderate' },
              { key: 'Severe', value: 'Severe' }
            ]
          }
        },
        {
          key: 'runnyNose',
          value: 'Runny nose',
          answer: {
            type: 'radio',
            name: 'runnyNoseOption',
            options: [
              { key: 'Mild', value: 'Mild' },
              { key: 'Moderate', value: 'Moderate' },
              { key: 'Severe', value: 'Severe' }
            ]
          }
        },
        {
          key: 'stuffyNose',
          value: 'Stuffy nose',
          answer: {
            type: 'radio',
            name: 'stuffyNoseOption',
            options: [
              { key: 'Mild', value: 'Mild' },
              { key: 'Moderate', value: 'Moderate' },
              { key: 'Severe', value: 'Severe' }
            ]
          }
        },
        {
          key: 'cough',
          value: 'Cough',
          answer: {
            type: 'radio',
            name: 'coughOption',
            options: [
              { key: 'Mild', value: 'Mild' },
              { key: 'Moderate', value: 'Moderate' },
              { key: 'Severe', value: 'Severe' }
            ]
          }
        },
        {
          key: 'sneezing',
          value: 'Sneezing',
          answer: {
            type: 'radio',
            name: 'sneezingOption',
            options: [
              { key: 'Mild', value: 'Mild' },
              { key: 'Moderate', value: 'Moderate' },
              { key: 'Severe', value: 'Severe' }
            ]
          }
        },
        {
          key: 'swollenEyes',
          value: 'Swollen eyes',
          answer: {
            type: 'radio',
            name: 'swollenEyesOption',
            options: [
              { key: 'Mild', value: 'Mild' },
              { key: 'Moderate', value: 'Moderate' },
              { key: 'Severe', value: 'Severe' }
            ]
          }
        },
        {
          key: 'itchySore',
          value: 'Itchy/sore throat',
          answer: {
            type: 'radio',
            name: 'itchySoreOption',
            options: [
              { key: 'Mild', value: 'Mild' },
              { key: 'Moderate', value: 'Moderate' },
              { key: 'Severe', value: 'Severe' }
            ]
          }
        },
        {
          key: 'rash',
          value: 'Rash',
          answer: {
            type: 'radio',
            name: 'rashOption',
            options: [
              { key: 'Mild', value: 'Mild' },
              { key: 'Moderate', value: 'Moderate' },
              { key: 'Severe', value: 'Severe' }
            ]
          }
        },
        {
          key: 'earFullness',
          value: 'Ear fullness',
          answer: {
            type: 'radio',
            name: 'earFullnessOption',
            options: [
              { key: 'Mild', value: 'Mild' },
              { key: 'Moderate', value: 'Moderate' },
              { key: 'Severe', value: 'Severe' }
            ]
          }
        },
        {
          key: 'pressureOver',
          value: 'Pressure over cheeks and forehead',
          answer: {
            type: 'radio',
            name: 'pressureOverOption',
            options: [
              { key: 'Mild', value: 'Mild' },
              { key: 'Moderate', value: 'Moderate' },
              { key: 'Severe', value: 'Severe' }
            ]
          }
        },
        {
          key: 'allergicShiner',
          value: 'Allergic shiner (bruising under eyes)',
          answer: {
            type: 'radio',
            name: 'allergicShinerOption',
            options: [
              { key: 'Mild', value: 'Mild' },
              { key: 'Moderate', value: 'Moderate' },
              { key: 'Severe', value: 'Severe' }
            ]
          }
        },
        {
          key: 'troubleSleeping',
          value: 'Trouble sleeping',
          answer: {
            type: 'radio',
            name: 'troubleSleepingOption',
            options: [
              { key: 'Mild', value: 'Mild' },
              { key: 'Moderate', value: 'Moderate' },
              { key: 'Severe', value: 'Severe' }
            ]
          }
        },
        {
          key: 'fever',
          value: 'Fever',
          answer: {
            type: 'radio',
            name: 'feverOption',
            options: [
              { key: 'Mild', value: 'Mild' },
              { key: 'Moderate', value: 'Moderate' },
              { key: 'Severe', value: 'Severe' }
            ]
          }
        },
        {
          key: 'fatigue',
          value: 'Fatigue',
          answer: {
            type: 'radio',
            name: 'fatigueOption',
            options: [
              { key: 'Mild', value: 'Mild' },
              { key: 'Moderate', value: 'Moderate' },
              { key: 'Severe', value: 'Severe' }
            ]
          }
        },
        {
          key: 'bodyAches',
          value: 'Body aches',
          answer: {
            type: 'radio',
            name: 'bodyAchesOption',
            options: [
              { key: 'Mild', value: 'Mild' },
              { key: 'Moderate', value: 'Moderate' },
              { key: 'Severe', value: 'Severe' }
            ]
          }
        },
        {
          key: 'greenMucus',
          value: 'Green mucus',
          answer: {
            type: 'radio',
            name: 'greenMucusOption',
            options: [
              { key: 'Mild', value: 'Mild' },
              { key: 'Moderate', value: 'Moderate' },
              { key: 'Severe', value: 'Severe' }
            ]
          }
        },
        {
          key: 'other',
          value: 'Other',
          uncheckOthers: true,
          answer: {
            type: 'text',
            name: 'otherDesc',
            placeholder: 'Please specify'
          }
        }
      ]
    }
  },
  {
    // 3
    field: 'allergiesLong',
    label: 'How long do your allergy symptoms normally last? ',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: '48hrs', value: '48 hrs or less' },
        { key: 'less1week', value: 'Less than 1 week' },
        { key: 'more1week', value: 'More than 1 week' },
        { key: '1month', value: '1 month or more' },
        { key: 'allTime', value: 'All the Time' },
        { key: 'notExactly', value: 'Not exactly sure' }
      ]
    }
  },
  {
    // 4
    field: 'allergiesDiff',
    label:
      'Need to have a way to differentiate that they are having allergy symptoms and not cold symptoms. Do you have any reason to believe that your symptoms may be Covid 19 or infection related?  - Differential Diagnosis ( Select all that apply to you )',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'fever',
          value:
            'Are you experiencing any fever, fatigue, or body aches? Cough, gradually worsening breathing problems'
        },
        {
          key: 'travel',
          value: 'Have you travelled outside the country in the past 14 days?'
        },
        {
          key: 'aroundSick',
          value:
            'Have you been around anyone who has been sick or experiencing flu/cold like symptoms?'
        },
        {
          key: 'household',
          value: 'Is anyone in your household experiencing concerning symptoms?'
        },
        {
          key: 'LossTaste',
          value: 'Loss of taste or smell? Or any symptoms related to COVID 19?'
        },
        {
          key: 'other',
          value: 'Not entirely sure\nNone of these apply to me',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    // 5
    field: 'allergiesTriggers',
    label: 'What are triggers? Please select all that may apply',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'animals', value: 'Animals ( pets )' },
        { key: 'outdoor', value: 'Outdoor environments' },
        { key: 'indoor', value: 'Indoor environments' },
        { key: 'unknown', value: 'Unknown' },
        { key: 'seasonalChanges', value: 'Seasonal changes' }
      ]
    }
  },
  {
    // 6
    field: 'allergiesSurgeries',
    label:
      'Have you had any previous/recent surgeries? (Examples include: Nasal surgery, sinus surgery, rhinoplasty, septoplasty, polyp removal surgery, or facial surgery )',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            label:
              'If yes, explain when and associated complications/symptoms?',
            type: 'text',
            name: 'description'
          }
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    // 7
    field: 'allergiesSeasonal',
    label:
      'Have you previously been diagnosed with seasonal allergies, environmental allergies or allergic rhinitis by a healthcare professional?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            label: 'if Yes, when and which treatment was recommended? ',
            name: 'description',
            type: 'text'
          }
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    // 8
    field: 'allergiesFamily',
    label:
      'Is there a family history of allergies, asthma, eczema or hay fever? ',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            label: 'Which one? ',
            type: 'text',
            name: 'description',
            required: false
          }
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    // 9
    field: 'allergiesTesting',
    label:
      'Have you completed allergy testing in the past (Skin testing, involves prick/puncture and intradermal) and Blood testing involves serum allergen specific IgE testing)?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            label: 'When? Which kind of testing? What were the results?',
            type: 'text',
            name: 'description',
            required: false
          }
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    // 10
    field: 'allergiesShots',
    label: 'Have you previously had allergy shots ( Immunotherapy )?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            label: 'If yes, for how long, how effective was the treatment?',
            type: 'text',
            name: 'description',
            required: false
          }
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    // 11
    field: 'allergiesTreatments',
    label:
      'What treatments have you used in the past? How effective were they?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'antiHistamineEye',
          value: 'Anti-histamine eye drops or Eye injections',
          answer: {
            type: 'radio',
            name: 'antiHistamineEyeOption',
            options: [
              { key: 'effective', value: 'Effective' },
              { key: 'somewhatEffective', value: 'Somewhat effective' },
              { key: 'notEffective', value: 'Not effective' }
            ]
          }
        },
        {
          key: 'antiHistaminenNasal',
          value: 'Anti-histamine nasal sprays',
          answer: {
            type: 'radio',
            name: 'antiHistaminenNasalOption',
            options: [
              { key: 'effective', value: 'Effective' },
              { key: 'somewhatEffective', value: 'Somewhat effective' },
              { key: 'notEffective', value: 'Not effective' }
            ]
          }
        },
        {
          key: 'oral',
          value: 'Oral Anti-histamines',
          answer: {
            type: 'radio',
            name: 'oralOption',
            options: [
              { key: 'effective', value: 'Effective' },
              { key: 'somewhatEffective', value: 'Somewhat effective' },
              { key: 'notEffective', value: 'Not effective' }
            ]
          }
        },
        {
          key: 'intraNasal',
          value: 'Intra-nasal corticosteroids or steroid nasal sprays',
          answer: {
            type: 'radio',
            name: 'intraNasalOption',
            options: [
              { key: 'effective', value: 'Effective' },
              { key: 'somewhatEffective', value: 'Somewhat effective' },
              { key: 'notEffective', value: 'Not effective' }
            ]
          }
        },
        {
          key: 'combination',
          value: 'Combination Anti-histamine/corticosteroid',
          answer: {
            type: 'radio',
            name: 'combinationOption',
            options: [
              { key: 'effective', value: 'Effective' },
              { key: 'somewhatEffective', value: 'Somewhat effective' },
              { key: 'notEffective', value: 'Not effective' }
            ]
          }
        },
        {
          key: 'singulair',
          value: 'Singulair',
          answer: {
            type: 'radio',
            name: 'singulairOption',
            options: [
              { key: 'effective', value: 'Effective' },
              { key: 'somewhatEffective', value: 'Somewhat effective' },
              { key: 'notEffective', value: 'Not effective' }
            ]
          }
        },
        {
          key: 'AlternativeMethods',
          value: 'Alternative Methods (irrigations, humidifiers, etc )',
          answer: {
            type: 'radio',
            name: 'AlternativeMethodsOption',
            options: [
              { key: 'effective', value: 'Effective' },
              { key: 'somewhatEffective', value: 'Somewhat effective' },
              { key: 'notEffective', value: 'Not effective' }
            ]
          }
        },
        {
          key: 'trtConsumeNone',
          value: 'Have not been treated before',
          uncheckOthers: true,
          answer: {
            type: 'radio',
            name: 'trtConsumeNoneOption',
            options: [
              { key: 'effective', value: 'Effective' },
              { key: 'somewhatEffective', value: 'Somewhat effective' },
              { key: 'notEffective', value: 'Not effective' }
            ]
          }
        }
      ]
    }
  },
  {
    // 12
    field: 'allergiesPrevTreatments',
    label: 'Did previous treatments you use help?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            label: 'What were the treatments?',
            type: 'text',
            name: 'description',
            required: false
          }
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    // 13
    field: 'allergiesConsume',
    label: 'Do you consume any of the following? Select all that apply?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'nicotine',
          value: 'Nicotine'
        },
        {
          key: 'marijuana',
          value: 'Marijuana'
        },
        {
          key: 'alcohol',
          value: 'Alcohol'
        },
        {
          key: 'recreationalDrugs',
          value: 'Recreational drugs'
        },
        {
          key: 'none',
          value: 'None Apply'
        }
      ]
    }
  },
  {
    // 18
    field: 'allergiesQuestions',
    label: 'Any questions for the health care provider?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'description',
            required: false
          }
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    // 20
    field: 'allergiesPreferredTreatment',
    label: "What's your preferred treatment for your allergies?",
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'pills',
          value: 'Pills'
        },
        {
          key: 'spray',
          value: 'Spray'
        },
        {
          key: 'combo',
          value: 'Combo'
        },
        {
          key: 'eyeDrops',
          value: 'Eye drops'
        },
        {
          key: 'letDoctor',
          value: 'Let doctor/NP decide'
        }
      ]
    }
  }
];

export default questionsModels;